import {
	createFileRoute,
	Navigate,
	useRouteContext,
} from "@tanstack/react-router";

export const Route = createFileRoute("/")({
	component: App,
});

function App() {
	const { session } = useRouteContext({ from: "__root__" });

	if (session?.user) {
		return <Navigate to="/clubs" />;
	}

	return <Navigate to="/cadastro" />;
}
